import { DoqType, ResponsiveDoqWithSpeechBubble } from '@ardoq/doq';
import { EmptyStatesDoqContainer } from '@ardoq/graph';
import { t, type I18nLocale } from '@ardoq/i18n';
import { i18nLocale$ } from 'streams/i18nLocale$';
import { connect } from '@ardoq/rxbeach';
import { map } from 'rxjs';

type NoConnectedComponentsWorkspaceDoqProps = {
  doqType: DoqType;
  includeActions?: boolean;
  i18nLocale: I18nLocale;
};

const NoConnectedComponentsWorkspaceDoqBase = ({
  doqType,
  i18nLocale,
}: NoConnectedComponentsWorkspaceDoqProps) => {
  return (
    <EmptyStatesDoqContainer>
      <ResponsiveDoqWithSpeechBubble
        doqType={doqType}
        title={t(
          i18nLocale,
          'tabview:graphViews.emptyState.noConnectedComponentsWorkspace.title',
          'No connected components'
        )}
        message={t(
          i18nLocale,
          'tabview:graphViews.emptyState.noConnectedComponentsWorkspace.message',
          'Select a workspace containing at least one component which is connected to another component.'
        )}
      />
    </EmptyStatesDoqContainer>
  );
};
export const NoConnectedComponentsWorkspaceDoq = connect(
  NoConnectedComponentsWorkspaceDoqBase,
  i18nLocale$.pipe(map(i18nLocale => ({ i18nLocale })))
);
